import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import { StyledPill, Link, Close } from './styled';

const ReferralPill = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { referralLink } = useSelector((state) => state.nomadInsurance.referrals);
  const { width } = useWindowSize();

  if (!referralLink || !isVisible) return null;

  const sendGiftLink = '/nomad-insurance/profile/my-details/send-a-gift';

  return (
    <StyledPill>
      {width > SCREEN_SIZES.desktop ? (
        <span>
          Get $20 credits for you and a friend.{' '}
          <Link to={sendGiftLink}>Refer someone</Link>
        </span>
      ) : (
        <span>
          Give $20, get $20. <Link to={sendGiftLink}>Refer a friend</Link>
        </span>
      )}
      <Close onClick={() => setIsVisible(false)} />
    </StyledPill>
  );
};

export default ReferralPill;
